function initContestJudgingSettings() {
  const judgingTypeMain = 1;
  const judgingTypeAppraisals = 2;
  const judgingTypes = document.querySelectorAll('input[name="judging_type"]');
  const judgingTypesParams = document.querySelectorAll('.judging_type_params');

  judgingTypes?.forEach(function (typeInput) {
    typeInput.addEventListener('change', function (e) {
      const type = e.currentTarget;

      if (!type.checked) {
        console.log('!type.checked');
        console.log(!type.checked);
        return;
      }

      const currentType = type.getAttribute('value');

      judgingTypesParams?.forEach(function (block) {
        const inputs = block.querySelectorAll('input');

        if (block.getAttribute('data-judging-type') != currentType) {
          block.classList.add('d-none');

          inputs?.forEach(function (element) {
            element.disabled = true;
          });
        } else {
          block.classList.remove('d-none');

          inputs?.forEach(function (element) {
            element.disabled = false;
          });
        }
      });
    });
  });
}

export { initContestJudgingSettings }